var _style, _g, _defs, _path, _defs2, _rect, _defs3, _rect2, _defs4, _rect3, _defs5, _rect4, _defs6, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 156 128"
    },
    viewBox: "0 0 156 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_3_);stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{clip-path:url(#SVGID_5_);fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_7_);fill:#FF5F00;}\n\t.st3{clip-path:url(#SVGID_9_);fill:#EB001B;}\n\t.st4{clip-path:url(#SVGID_11_);fill:#F79E1B;}\n\t.st5{clip-path:url(#SVGID_13_);fill:#F79E1B;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14,30c0-3.3,2.7-6,6-6h116c3.3,0,6,2.7,6,6v68c0,3.3-2.7,6-6,6H20c-3.3,0-6-2.7-6-6V30z",
    id: "SVGID_1_"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14,30c0-3.3,2.7-6,6-6h116c3.3,0,6,2.7,6,6v68c0,3.3-2.7,6-6,6H20c-3.3,0-6-2.7-6-6V30z",
    id: "SVGID_2_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_2_"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,30c0-3.3,2.7-6,6-6h116c3.3,0,6,2.7,6,6v68c0,3.3-2.7,6-6,6H20c-3.3,0-6-2.7-6-6V30z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.3,91.8V88c0-1.4-0.8-2.3-2.3-2.4c-0.8,0-1.5,0.2-2.1,1.1c-0.4-0.7-1.1-1.1-2-1.1      c-0.6,0-1.3,0.2-1.8,0.9v-0.7h-1.2v6h1.2v-3.4c0-1,0.6-1.6,1.5-1.6s1.3,0.6,1.3,1.6v3.4h1.2v-3.4c0-1,0.6-1.6,1.5-1.6      s1.4,0.6,1.4,1.6v3.4H55.3z M74.7,85.8h-2.2V84h-1.2v1.8H70v1.1h1.3v2.8c0,1.4,0.5,2.2,2,2.2c0.6,0,1.2-0.2,1.6-0.5l-0.4-1.1      c-0.4,0.2-0.8,0.3-1.1,0.3c-0.6,0-0.9-0.4-0.9-1v-2.8h2.2V85.8z M85.8,85.7c-0.7,0-1.3,0.3-1.6,0.9v-0.7H83v6h1.2v-3.4      c0-1,0.5-1.6,1.3-1.6c0.3,0,0.5,0,0.8,0.2l0.4-1.1C86.4,85.7,86,85.7,85.8,85.7z M69,86.3c-0.6-0.4-1.5-0.6-2.4-0.6      c-1.5,0-2.4,0.7-2.4,1.9c0,1,0.7,1.6,2,1.7l0.6,0.1c0.7,0.1,1.1,0.3,1.1,0.7c0,0.5-0.5,0.8-1.4,0.8s-1.5-0.3-2-0.6l-0.6,0.9      c0.9,0.6,1.9,0.8,2.6,0.8c1.7,0,2.7-0.8,2.7-1.9c0-1-0.7-1.6-2-1.8l-0.6-0.1c-0.6-0.1-1.1-0.2-1.1-0.6s0.5-0.7,1.2-0.7      c0.8,0,1.5,0.3,1.9,0.5L69,86.3z M87.1,88.8c0,1.8,1.2,3.1,3.1,3.1c0.9,0,1.5-0.2,2.1-0.7l-0.6-0.9c-0.5,0.3-1,0.5-1.6,0.5      c-1,0-1.8-0.8-1.8-2s0.8-2,1.8-2c0.6,0,1.1,0.2,1.6,0.5l0.6-0.9c-0.6-0.5-1.2-0.7-2.1-0.7C88.3,85.7,87.1,87,87.1,88.8z       M78.7,85.7c-1.7,0-2.9,1.3-2.9,3.1c0,1.9,1.2,3.1,3,3.1c0.9,0,1.7-0.2,2.4-0.8l-0.6-0.9c-0.5,0.4-1.1,0.6-1.7,0.6      c-0.8,0-1.7-0.5-1.8-1.5h4.5c0-0.2,0-0.3,0-0.5C81.5,86.9,80.4,85.7,78.7,85.7z M78.7,86.8c0.9,0,1.5,0.6,1.6,1.5h-3.2      C77.2,87.4,77.8,86.8,78.7,86.8z M62.6,88.8v-3h-1.2v0.7c-0.4-0.5-1.1-0.9-1.9-0.9c-1.7,0-2.9,1.3-2.9,3.1      c0,1.8,1.3,3.1,2.9,3.1c0.8,0,1.5-0.3,1.9-0.9v0.7h1.2V88.8z M57.7,88.8c0-1.1,0.7-2,1.9-2c1.1,0,1.8,0.9,1.8,2      c0,1.2-0.7,2-1.8,2C58.5,90.8,57.7,89.9,57.7,88.8z M103.8,85.7c-0.7,0-1.3,0.3-1.6,0.9v-0.7H101v6h1.2v-3.4      c0-1,0.5-1.6,1.3-1.6c0.3,0,0.5,0,0.8,0.2l0.4-1.1C104.4,85.7,104,85.7,103.8,85.7z M113.4,90.9c0.1,0,0.2,0,0.2,0      c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2s0,0.1,0,0.2s0,0.2,0,0.2c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.1      s-0.2,0-0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2s0-0.1,0-0.2s0-0.2,0-0.2      c0-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1C113.2,90.9,113.3,90.9,113.4,90.9z M113.4,92c0.1,0,0.1,0,0.2,0      s0.1-0.1,0.1-0.1l0.1-0.1c0-0.1,0-0.1,0-0.2s0-0.1,0-0.2s-0.1-0.1-0.1-0.1l-0.1-0.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0      s-0.1,0.1-0.1,0.1l-0.1,0.1c0,0.1,0,0.1,0,0.2s0,0.1,0,0.2s0.1,0.1,0.1,0.1l0.1,0.1C113.3,92,113.3,92,113.4,92z M113.4,91.2      c0.1,0,0.1,0,0.2,0l0.1,0.1v0.1c0,0-0.1,0-0.1,0.1l0.2,0.2h-0.1l-0.2-0.2h-0.1v0.2h-0.1v-0.6h0.1V91.2z M113.3,91.3L113.3,91.3      L113.3,91.3l0.2,0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1C113.5,91.2,113.5,91.2,113.3,91.3L113.3,91.3L113.3,91.3z M99.2,88.8v-3H98      v0.7c-0.4-0.5-1.1-0.9-1.9-0.9c-1.7,0-2.9,1.3-2.9,3.1c0,1.8,1.3,3.1,2.9,3.1c0.8,0,1.5-0.3,1.9-0.9v0.7h1.2V88.8z M94.4,88.8      c0-1.1,0.7-2,1.9-2c1.1,0,1.8,0.9,1.8,2c0,1.2-0.7,2-1.8,2C95.1,90.8,94.4,89.9,94.4,88.8z M111.2,88.8v-5.4H110v3.1      c-0.4-0.5-1.1-0.9-1.9-0.9c-1.7,0-2.9,1.3-2.9,3.1c0,1.8,1.3,3.1,2.9,3.1c0.8,0,1.5-0.3,1.9-0.9v0.7h1.2V88.8z M106.4,88.8      c0-1.1,0.7-2,1.9-2c1.1,0,1.8,0.9,1.8,2c0,1.2-0.7,2-1.8,2C107.1,90.8,106.4,89.9,106.4,88.8z",
    id: "SVGID_4_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_4_"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 18.7,
    width: 78.1,
    x: 40.9,
    y: 78.4
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 35.3,
    id: "SVGID_6_",
    width: 21.6,
    x: 67.6,
    y: 40.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_6_"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 45.3,
    width: 31.6,
    x: 62.6,
    y: 35.5
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M69.9,58.1c0-7.2,3.4-13.5,8.6-17.6c-3.8-3-8.6-4.8-13.9-4.8c-12.4,0-22.4,10-22.4,22.4      s10,22.4,22.4,22.4c5.2,0,10-1.8,13.9-4.8C73.2,71.6,69.9,65.2,69.9,58.1",
    id: "SVGID_8_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_8_"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    height: 54.9,
    width: 46.3,
    x: 37.1,
    y: 30.7
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.6,72v-0.7h0.3v-0.1h-0.7v0.1h0.3L112.6,72L112.6,72z M114,72v-0.9h-0.2l-0.3,0.6l-0.3-0.6H113V72      h0.2v-0.7l0.2,0.6h0.2l0.2-0.6V72H114z",
    id: "SVGID_10_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_10_"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    height: 10.9,
    width: 11.9,
    x: 107.1,
    y: 66.1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M114.7,58.1c0,12.4-10,22.4-22.4,22.4c-5.2,0-10-1.8-13.9-4.8c5.2-4.1,8.6-10.5,8.6-17.6      c0-7.2-3.4-13.5-8.6-17.6c3.8-3,8.6-4.8,13.9-4.8C104.7,35.7,114.7,45.7,114.7,58.1",
    id: "SVGID_12_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_13_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_12_"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    height: 54.9,
    width: 46.3,
    x: 73.4,
    y: 30.7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.17fcc34a6f63cb4935086196e9095e15.svg";
export { ForwardRef as ReactComponent };